import { render, staticRenderFns } from "./Workspaces.vue?vue&type=template&id=17ca6436&scoped=true&"
import script from "./Workspaces.vue?vue&type=script&lang=js&"
export * from "./Workspaces.vue?vue&type=script&lang=js&"
import style0 from "./Workspaces.vue?vue&type=style&index=0&id=17ca6436&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ca6436",
  null
  
)

export default component.exports